export const productColor = {
  none: '#449afd',
  data: '#449afd',
  measure: '#449afd',
  engage: '#449afd',
  influence: '#449afd',
  admin: '#449afd',
}
